import * as React from "react";
const EditIcon = (props) => (
  <svg
    width={17}
    height={18}
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.8898 2.70245C12.0734 2.51876 12.2915 2.37304 12.5315 2.27363C12.7715 2.17421 13.0288 2.12305 13.2886 2.12305C13.5483 2.12305 13.8056 2.17421 14.0456 2.27363C14.2856 2.37304 14.5037 2.51876 14.6874 2.70245C14.8711 2.88615 15.0168 3.10422 15.1162 3.34423C15.2156 3.58424 15.2668 3.84148 15.2668 4.10126C15.2668 4.36105 15.2156 4.61828 15.1162 4.85829C15.0168 5.0983 14.8711 5.31638 14.6874 5.50007L5.24541 14.942L1.39868 15.9911L2.44779 12.1444L11.8898 2.70245Z"
      stroke="#0F172A"
      strokeWidth={1.39881}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default EditIcon;
